const moment = require('moment')

function formatDate (date) {
  return format(date, 'YYYY-MM-DD')
}

function format (date, pattern) {
  if (!date) {
    return null
  }
  if (!pattern) {
    return null
  }
  return moment(date).format(pattern)
}

module.exports = {
  formatDate
}



// WEBPACK FOOTER //
// ./src/common/utils/date-util.js